import { render } from "./ReviewView.vue?vue&type=template&id=b233ec8c"
import script from "./ReviewView.vue?vue&type=script&lang=js"
export * from "./ReviewView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__